
import React ,{Component} from 'react'; 
import { NavLink,Outlet } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import LogoutIcon from '@mui/icons-material/Logout';
import logo from './images/logo.jpg';

import CloseIcon from '@mui/icons-material/Close';
export default class Layoutmenu extends Component {

   constructor(props) {
      super(props);
	  
      this.state = {
		  open:false,
    sb_id: 0,
   
	  }
   }
      
render() { 
 return (
 
  
<React.Fragment>
<div 
  className="adminheaderbg" 
  style={{ 
    padding: "10px 20px", 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center" 
  }}
>
  <img src={logo} alt="logo" />
</div>
<div className={this.state.wrapopen ? "site-wrap wrapactive" : "site-wrap"}>
<Outlet />
</div>
 <div className="footerbg">
		   <p>© Copyright {(new Date().getFullYear())} Global Buzz, All Rights Reserved</p>
		  </div>
</React.Fragment>

);
}	 
	  
}
	
  





















  
 